export default __webpack_public_path__ + "static/media/sh-eye-active.0783a8d7.svg";